<template>
	<el-container class="ai-wrap">
		<!-- 移动端侧边栏遮罩 -->
		<div class="mobile-sidebar-overlay" v-show="showMobileSidebar" @click="showMobileSidebar = false"></div>

		<!-- 移动端侧边栏切换按钮 -->
		<div class="mobile-sidebar-toggle" @click="showMobileSidebar = !showMobileSidebar">
			<i :class="showMobileSidebar ? 'el-icon-close' : 'el-icon-menu'" style="font-size: 18px"></i>
		</div>

		<LeftSide
			ref="leftSideRef"
			:class="{ 'mobile-sidebar-open': showMobileSidebar }"
			:asideList="groupedAsideList"
			@getAsideList="getAsideList"
			@loadMore="loadMore"
			@openChat="showMobileSidebar = false"
		></LeftSide>

		<MainBox :asideList="groupedAsideList" :chatItem="chatItem" @updateAsideList="updateAsideList"></MainBox>

	</el-container>
</template>

<script>
import LeftSide from './components/LeftSide.vue';
import MainBox from './components/MainBox.vue';
import { mapGetters } from 'vuex';
import { getConversationsList, getAiCount, createNewConversations, renameConversation, deleteConversation, clearConversation, feedback, listMsg } from '@/api/ai/ai.js';

export default {
	data() {
		return {
			//左边菜单
			asideList: [],
			// 分组后的对话列表
			groupedAsideList: {
				pinned: [], // 置顶
				today: [], // 今天
				earlier: [] // 更早
			},
			//当前聊天项
			chatItem: {},
			//分页
			searchParams: {
				pageNum: 1,
				pageSize: 40,
				user_id: ''
			},
			total: 0,
			// 加载状态
			loading: false,
			// 是否还有更多数据
			hasMore: true,
			// 移动端侧边栏开关
			showMobileSidebar: false
		};
	},
	components: {
		MainBox,
		LeftSide
	},
	methods: {
		// 对对话列表进行分组
		groupAsideList(list) {
			const now = new Date();
			const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);

			const grouped = {
				pinned: [],
				today: [],
				earlier: []
			};

			list.forEach(item => {
				if (item.status === 1) {
					grouped.pinned.push(item);
				} else {
					try {
						const createTime = new Date(item.create_time);
						if (isNaN(createTime.getTime())) {
							console.warn('无效的时间格式:', item.create_time);
							grouped.earlier.push(item);
							return;
						}
						if (createTime >= todayStart) {
							grouped.today.push(item);
						} else {
							grouped.earlier.push(item);
						}
					} catch (error) {
						console.error('时间解析错误:', error);
						grouped.earlier.push(item);
					}
				}
			});

			this.groupedAsideList = grouped;
		},

		getAsideList(isLoadMore = false) {
			this.loading = true;
			this.searchParams.user_id = this.uinfo.id;

			getConversationsList(this.searchParams)
				.then(res => {
					this.loading = false;
					const list = res.data.data || [];
					this.total = res.data.total || 0;

					if (isLoadMore) {
						// 加载更多：追加数据
						this.asideList = [...this.asideList, ...list];
					} else {
						// 首次加载：替换数据
						this.asideList = list;
					}

					// console.log('this.asideList...', this.asideList);
					// console.log('this.total...', this.total);

					// 判断是否加载完毕
					this.hasMore = this.asideList.length < this.total;
					// console.log('this.hasMore...111', this.hasMore);

					// 重新分组
					this.groupAsideList(this.asideList);
				})
				.catch(() => {
					this.loading = false;
					// 加载更多失败时回退页码
					if (isLoadMore) {
						this.searchParams.pageNum--;
					}
				});
		},

		updateAsideList(val) {
			this.asideList.today = val;
		},

		loadMore() {
			return
			console.log('this.hasMore...', this.hasMore);
			if (!this.hasMore) return;
			this.searchParams.pageNum++;
			this.getAsideList(true);
		}
	},
	created() {
		if (this.uisLogin && this.uinfo && this.uinfo.id) {
			this.getAsideList();
		}
	},

	computed: {
		...mapGetters('User', ['uinfo', 'uisLogin'])
	},

	watch: {
		uisLogin: function (newVal, oldVal) {
			if (newVal && !oldVal) {
				setTimeout(() => {
					if (this.uinfo && this.uinfo.id) {
						this.getAsideList();
					}
					this.$refs.leftSideRef.openNewChat();
				}, 500);
			}
		},
		// 登录后 uinfo 异步加载完成时，补调 getAsideList
		uinfo: {
			handler(newVal) {
				if (newVal && newVal.id && this.uisLogin && !this.asideList.length) {
					this.getAsideList();
				}
			},
			immediate: false
		}
	}
};
</script>

<style lang="less" scoped>
	.ai-wrap {
		display: flex !important;
		justify-content: space-between;
		position: relative;
	}

	// 移动端侧边栏切换按钮
	.mobile-sidebar-toggle {
		display: none;
		position: fixed;
		left: 8px;
		top: 80px;
		z-index: 100;
		width: 36px;
		height: 36px;
		background: #155dfc;
		color: #fff;
		border-radius: 10px;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
	}

	// 移动端侧边栏遮罩
	.mobile-sidebar-overlay {
		display: none;
		position: fixed;
		inset: 0;
		background: rgba(0, 0, 0, 0.4);
		z-index: 90;
	}

	// ===== 平板及以下：侧边栏变抽屉 =====
	@media screen and (max-width: 1023px) {
		.mobile-sidebar-toggle {
			display: flex;
		}

		.mobile-sidebar-overlay {
			display: block;
		}

		.aside-container {
			position: fixed !important;
			left: 0;
			top: 0;
			z-index: 95;
			height: 100vh !important;
			width: 280px !important;
			transform: translateX(-100%);
			transition: transform 0.3s ease;
			overflow-y: auto;
			background: #f9fafb;
			box-shadow: 2px 0 12px rgba(0, 0, 0, 0.1);

			&.mobile-sidebar-open {
				transform: translateX(0);
			}

			:deep(.flexCenter[style*="fixed"]) {
				position: static !important;
				width: 100% !important;
				height: auto !important;
				padding: 12px 16px;
			}

			.aside-main {
				max-height: calc(100vh - 130px);
				overflow-y: auto;
				margin-top: 0 !important;
			}
		}

		.ai-wrap {
			flex-direction: column;
		}

		.main-container {
			padding-left: 48px;
		}

		.chat-submit-main,
		.chat-submit-bar {
			max-width: 100%;
			width: 100%;
		}
	}

	// ===== 手机 =====
	@media screen and (max-width: 767px) {
		.main-container {
			padding: 0 8px 0 48px;
			height: calc(100vh - 60px) !important;
		}

		.mobile-sidebar-toggle {
			top: 76px;
			left: 8px;
			width: 32px;
			height: 32px;
			border-radius: 8px;
		}

		// 消息内容区不遮挡
		.chat-content-content-title {
			width: 100%;
			max-width: 100%;
			margin: 50px auto 12px;
			padding: 0;
		}

		.chat-content-title {
			font-size: 16px;
			width: 100% !important;
			left: 0;
			padding: 12px 8px 12px 44px;
		}

		// 输入区不挤
		.chat-submit-main,
		.chat-submit-bar {
			width: 100%;
			max-width: 100%;
		}

		.chat-submit-container {
			padding: 0 4px;
		}

		// 消息气泡适配
		.message-bubble {
			padding: 10px 12px;
			font-size: 13px;
			border-radius: 12px;
		}

		.user-message-wrapper {
			max-width: 85%;
		}

		.avatar {
			width: 30px;
			height: 30px;
			border-radius: 8px;
		}

		.avatar-text {
			font-size: 11px;
		}

		.chat-content-answer {
			gap: 8px;
			margin: 12px 0;
		}

		.chat-content-query {
			gap: 8px;
			margin: 10px 0;
		}

		.welcome-title {
			font-size: 18px;
		}

		.welcome-subtitle {
			font-size: 12px;
		}

		.welcome-icon {
			width: 44px;
			height: 44px;
			font-size: 20px;
		}
	}
</style>
